// @ts-nocheck
import { Pin, ListOrdered} from "lucide-react"
import { Badge } from "@/components/ui/badge"
import {
    HoverCard,
    HoverCardContent,
    HoverCardTrigger,
  } from "@/components/ui/hover-card"


// design inspo https://claude.site/artifacts/57136d44-a03f-4838-b1ea-9a9160e13b22

export default function ProfileList() {
    return(
        <section className="flex flex-col gap-4 justify-center items-center mt-15">
            <ListItem listName="albums that're better than sex" listDesc="i promise i've had sex" listPinned={true} listRanked={true}/> 

            <ListItem listName="peak weeb shit" listImg="http://image.tmdb.org/t/p/w500//vR7hwaGQ0ySRoq1WobiNRaPs4WO.jpg" 
            listDesc="watch any of these and it'll put you on, i stg" itemCount={8} listType="shows" listPinned={true} listRanked={true}/>

            <ListItem listName="i only watch good movies" listImg="http://image.tmdb.org/t/p/w500//g5IoYeudx9XBEfwNL0fHvSckLBz.jpg" 
            listDesc="i love edgar wright" itemCount={13} listType="movies" listPinned={true} listRanked={true}/>

            <ListItem listName="music to puke to" listImg="https://i.scdn.co/image/ab67616d0000b273c8b444df094279e70d0ed856" listType="songs"
            listDesc="made with love for willem <3"/>

            <ListItem listName="i <3 sitcoms" listImg="http://image.tmdb.org/t/p/w500//maBJkaBM4UqAttn9UkLCfZEVEfk.jpg" listType="shows"
            listDesc="i dont like to feel things, haha!"/> 


        </section>
    )
}

interface ListItemProps {
    listName:string,
    listDesc:string,
    listImg:string,
    listType:"songs"|"albums"|"artists"|"movies"|"shows",
    listLink:string,
    listPinned:boolean,
    itemCount:Number,
    listRanked:boolean,
}


function ListItem ({listName="gooner material", listDesc="I'm too cool for a description", listImg="https://i.scdn.co/image/ab67616d0000b273a12c5353b3d0385c6ce8c103",
    listType="albums",listLink="https://google.com",listPinned=false, itemCount=11, listRanked=false}:ListItemProps) {

    return(
        <article className="relative flex w-100 md:w-150 h-50 rounded-lg bg-primary text-muted-foreground text-lg hover:cursor-pointer hover:bg-neutral-800 ease-in-out duration-200">
            <div className="flex flex-col break-words my-4 ml-4 order-2 justify-between">
                <header className="">
                    <h2 className="text-secondary font-semibold">{listName}</h2>
                    <p className="text-sm text-neutral-400" >{listDesc}</p>
                </header>
                <footer>
                    <p className="text-sm text-neutral-400" >{`${itemCount} items`}</p>
                </footer>
            </div>
            <div className="flex">
                {
                    listType == "albums" || listType == "songs" || listType == "artists" ? 
                    <img className="h-50 rounded-l-lg" src={listImg} alt={`Image of content featured in list`}/> : 
                    <img className="h-50 rounded-l-lg" src={listImg} alt={`Image of content featured in list`}/>
                }
                <Badge variant="secondary" className="absolute bottom-1 left-1 font-semibold w-fit h-fit text-secondary bg-black/40 backdrop-blur-sm capitalize">{listType}</Badge>
                
            </div>
            {
                listPinned ? <Pin className="absolute text-secondary right-4 top-4 h-6 w-6 rotate-45" /> : null
            }
            {
                listRanked ? <ListOrderedIcon />: null
            }
            
        </article>
    )
    
    
}

function ListOrderedIcon () {
    return(
    <HoverCard>
        <HoverCardTrigger>
            <ListOrdered className="absolute text-secondary  right-4 bottom-4 h-6 w-6" /> 
        </HoverCardTrigger>
        
        <HoverCardContent className="bg-foreground text-background">
            This is a ranked list
        </HoverCardContent>
    </HoverCard> 

    )
}
   